import { Box } from "@mui/material";
import SideSheetDrawer from "../../../../../components/SidesheetDrawer";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import CMSForm from "../paper-claim/CMSFom";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import { useEffect, useState } from "react";
import { useGetClaimById } from "../../../../../queries/billings/claims/use-get-claim-by-id";

interface ViewPaperClaimDrawerProps {
  disclosureHost: DisclosureHost;
}

const ViewPaperClaimDrawer = ({
  disclosureHost,
}: ViewPaperClaimDrawerProps) => {
  // Check if disclosureHost.data is a UUID (string) or already claim data (object)
  const isUuid = typeof disclosureHost?.data === "string";
  const claimUuid = isUuid ? disclosureHost?.data : undefined;

  // Fetch claim data if UUID is provided
  const { data: claimData, isLoading: isLoadingClaim } = useGetClaimById({
    claimUuid: claimUuid ?? "",
  });

  // Determine the prefill data: use fetched claim data if UUID was provided, otherwise use the data directly
  const prefillData = isUuid ? claimData?.data : disclosureHost?.data;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // Create a modified disclosure host with the prefill data
  // This ensures CMSForm receives the correct data (either fetched or passed directly)
  const disclosureHostWithData = {
    ...disclosureHost,
    data: prefillData
      ? { ...prefillData, uuid: prefillData?.uuid ?? claimUuid }
      : prefillData,
  };

  // Only render CMSForm when we have prefill data (if UUID was provided, wait for data to load)
  const shouldRenderCMSForm = isUuid ? !!prefillData : true;

  return (
    <SideSheetDrawer
      title=""
      w="55vw"
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
    >
      <LoadingOverlay
        isLoading={isLoading || isLoadingClaim || !shouldRenderCMSForm}
      />
      {shouldRenderCMSForm && (
        <Box>
          <CMSForm disclosureHost={disclosureHostWithData} />
        </Box>
      )}
    </SideSheetDrawer>
  );
};

export default ViewPaperClaimDrawer;
